module.exports = __webpack_public_path__ + "img/10-1_07.579e3395.jpg";